import update from 'immutability-helper';

export const consts = {
	action: 'ENTITY_JUNCTION',
	keys: {
		CENTER_TERM_PROGRAM: 'centerTermPrograms'
	} 
}

const junction = (state = { centerTermPrograms: {} }, action) => {
	switch (action.type) {
		case consts.action:
			let newState = state;
			Object.keys(action.payload.junctions).forEach(key => {
				newState = update(newState, {
					[key]: { $merge: action.payload.junctions[key] }
				});
			});
			return newState;
		default:
			return state;
	}
};

export default junction;